import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {Order} from "../../../../../models/Order";
import {toast} from "react-toastify";
import {
    GetEmployeeProviderLists, GetSupplierOrder, EmployeeFlowUpdateOrder
} from "../../../../../reduxToolkit/EmployeeProviders/EmployeeProvidersApi";
import {t} from "i18next";
import {errorMsg} from "../../../../../Apis/functions";
import HandleChange from "../../../../../Helpers/HandleChange";

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @jobTitle Full Stack Developer
 */
export const EmployeeFlowUpdateOrderApp =()=>{

    const dispatch = useDispatch();
    const { id } = useParams();
    const [emptyFields, setEmptyFields] = useState(false);
    const [order, setOrder] = useState({...Order});
    const { handleChange } = HandleChange({ model: order, setModel: setOrder });

    const UpdateOrderHandler = async () => {
        if (!order.isValid()) {
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);

        dispatch(EmployeeFlowUpdateOrder(order.toUpdate())).then(({ payload: { data: { success, code } } }) => {
            if(success){
                getData();
                toast.success(t('has_been_updated_successfully'));
            }else errorMsg(code)
        });
    };

    useEffect(() => {
        dispatch(GetEmployeeProviderLists());
        getData();
    }, []);

    const getData = () => {
        dispatch(GetSupplierOrder(id)).then(({ payload: { data: { data, success } } }) => {
            if(success){
                setOrder(order.set(data));
            }
        });
    }

    return {
        UpdateOrderHandler,
        order,
        emptyFields,
        handleChange
    }
}
